const inventory = {
  title: "Inventory",
  subtitle: "Manage your supplies, treatments and their consumption.",
  back: "Back",
  loading: "Loading…",

  currencyAlert:
    'To use it properly, we recommend completing the "Currencies" section.',
  currencyAlertSecretary:
    'The professional has not completed the "Currencies" section of their profile yet.',

  // Secretary: inventory of each of their professionals
  owner: {
    label: "Inventory of",
    placeholder: "Choose a professional",
    noProfessionals:
      "You are not working with any professional yet, so there are no inventories to show.",
  },
  goToCurrencies: "Go to Currencies",

  reorderTitle: "Supplies to restock",
  reorderEmpty: "Stock in normal conditions",
  reorderHint: "These supplies reached or exceeded their stock threshold.",

  expiringTitle: "Supplies about to expire",
  expiringEmpty: "No supplies close to expiring",
  expiringHint: "These supplies reached their expiration alert date or have already expired.",
  expiresOn: "Expires on {{date}}",
  expiredOn: "Expired on {{date}}",

  nav: {
    supplies: "Supplies",
    newSupply: "+ Supply",
    suppliesList: "Supplies list",
    treatments: "Treatments",
    newTreatment: "Treatment",
    charts: "Charts",
    currencies: "Currencies",
  },

  currencies: {
    title: "Currencies",
    defaultTitle: "Default currency",
    defaultDescription: "this is the main currency",
    selectCurrency: "Select a currency",
    decimalQuestion: "How do you want decimal positions to look?",
    decimalComma: "Comma ( , )",
    decimalDot: "Dot ( . )",
    altTitle: "Alternative currency",
    altDescription: "conversion currency, for supplies that use it",
    exchangeRate: "Exchange rate",
    exchangeRatePlaceholder: "Enter the value",
    lastUpdate: "Last update",
    notUpdatedYet: "Not updated yet",
    exchangeHint:
      "The value you enter will be multiplied by the default currency. If your currency is Argentine Pesos (AR$) and you have supplies in US Dollars (U$S), the value you enter will reflect the price in Argentine Pesos. Example: my favorite scalpel is worth U$S 500 and the Dollar is AR$ 2000 per U$S 1, the system will show AR$ 1,000,000 in the supplies list with the decimal position you selected.",
    save: "Save",
    saved: "Currency settings saved",
    saveError: "Error saving settings",
  },

  supply: {
    newTitle: "New Supply",
    editTitle: "Edit Supply",
    decimalHint:
      'If you have costs with decimal positions, enter them the same way you selected in the "Currencies" section.',
    description: "Description",
    descriptionPlaceholder: "Supply description",
    stock: "Stock",
    stockHint: "current stock",
    unitCostIn: "Unit cost in {{currency}}",
    unitCostAltIn: "Unit cost in {{currency}} (alternative currency)",
    reorderThreshold: "Stock threshold",
    reorderThresholdHint: "We will notify you when the supply reaches this number.",
    comments: "Comments",
    commentsPlaceholder:
      "anything you want to clarify about the supply. E.g.: 1 unit equals 0.5 meters",
    lastUpdate: "Last update",
    zeroNote:
      "Important: if a supply reaches 0 or below 0, the system will keep working.",
    create: "Create Supply",
    save: "Save",
    created: "Supply created",
    updated: "Supply updated",
    saveError: "Error saving the supply",
    requiredDescription: "Enter the supply description",
    requiredThreshold: "Enter the stock threshold",
    expirationDate: "Expiration date",
    expirationDateHint: "optional, if the supply expires",
    expirationAlertDate: "Expiration alert",
    alertOneMonth: "1 month before",
    alertOneAndHalfMonths: "1.5 months before",
    expirationAlertHint:
      "Choose the date you want to be notified before the supply expires. If your product has a 6-month shelf life, we recommend setting the alert one and a half or one month before so you have time to restock.",
    requiredExpirationForAlert: "Enter the expiration date to use the alert",
    alertAfterExpiration: "The alert date must be on or before the expiration date",
    configureCurrencyFirst:
      'First configure the "Currencies" section to choose your default currency.',
  },

  list: {
    searchPlaceholder: "Search supply by description…",
    description: "Description",
    lastUpdate: "Last update",
    stock: "Stock",
    history: "History",
    actions: "Actions",
    edit: "Edit",
    empty: "You don't have any supplies yet",
    delete: "Delete",
    confirmDelete: "Are you sure you want to delete this supply?",
    deleted: "Supply deleted",
    expiration: "Expires",
  },

  history: {
    title: "History of {{name}}",
    date: "Date",
    change: "Change",
    stock: "Stock",
    unitCost: "Unit cost",
    expiration: "Expiration",
    empty: "No movements recorded",
    types: {
      create: "Creation",
      update: "Edit",
      consumption: "Consumption",
      adjustment: "Adjustment",
    },
  },

  treatment: {
    listTitle: "Treatments",
    intro:
      "Don't worry about going into so much detail. If you assign a treatment to a patient, we will ask you before saving what was used.",
    empty: "You don't have any treatments yet",
    newTitle: "New Treatment",
    editTitle: "Edit Treatment",
    name: "Name",
    namePlaceholder: "Chemical peel, APEX, BOTOX, COLELAP, etc.",
    supplies: "Supplies",
    suppliesHint: "select the supply and quantity each treatment uses",
    searchSupply: "Search supply by name…",
    quantity: "Quantity",
    unitCost: "Unit cost",
    subtotal: "Subtotal",
    subtotalIn: "Subtotal {{currency}}",
    add: "Add",
    remove: "Delete",
    selectedSupplies: "Treatment supplies",
    noSupplies: "You haven't added any supplies yet",
    totalCost: "Total treatment cost",
    totalCostPrivate: "this information is private",
    noExchangeRate: "Set the exchange rate in Currencies",
    lastUpdate: "Last update",
    save: "Save Treatment",
    created: "Treatment created",
    updated: "Treatment updated",
    saveError: "Error saving the treatment",
    requiredName: "Enter the treatment name",
    requiredItems: "Add at least one supply",
    edit: "Edit",
    stats: "Statistics",
    delete: "Delete",
    confirmDelete: "Are you sure you want to delete this treatment?",
    deleted: "Treatment deleted",
  },

  stats: {
    title: "Statistics of {{name}}",
    timesUsed: "Times used",
    totalCost: "Accumulated cost",
    lastUsed: "Last used",
    never: "Never",
    monthlyUsage: "Usage per month",
    empty: "This treatment hasn't been used yet",
  },

  consumption: {
    title: "Supply consumption",
    question:
      'Did you use all the supplies of "{{name}}"? Modify them in the table below if needed and stock will be updated.',
    supply: "Supply",
    quantity: "Quantity used",
    confirm: "Confirm",
    cancel: "Cancel",
    applied: "Consumption recorded and stock updated",
    applyError: "Error recording the consumption",
    selectTreatment: "Treatment (optional)",
    selectTreatmentPlaceholder: "No treatment",
    noTreatments: "You have no treatments created",
  },

  charts: {
    title: "Charts",
    treatmentConsumption: "Treatment consumption",
    supplyConsumption: "Supply consumption",
    topTreatments: "Top 5 most used treatments",
    topSupplies: "Top 5 most used supplies",
    empty: "There isn't enough data to display yet",
    count: "Count",
    quantity: "Quantity",
  },

  common: {
    saving: "Saving…",
    cancel: "Cancel",
    close: "Close",
  },
};

export default inventory;
